import React, { useState, use, useEffect } from "react";
import ReactDOM from "react-dom";
import "./GeneralTaskPanelsManager.css";
import Modal from "../Modal/Modal";
import { set } from "lodash";
function GeneralTaskPanelsManager() {
  const [panels, setPanels] = useState([]);

  const [currentPanel, setCurrentPanel] = useState(null);

  useEffect(() => {
    const panelsVisibility = window.GlobalData.getGeneralTaskPanelsVisibility();

    setPanels(
      window.DataStorage.getGeneralTaskPanels().map((panel) => {
        return {
          ...panel,
          editable: panel.OwnerId === window.myid,
          isVisible: panelsVisibility.find((p) => p.Id === panel.Id)
            ? panelsVisibility.find((p) => p.Id === panel.Id).isVisible
            : true,
        };
      })
    );
  }, []);

  const renameCurrentPanel = () => {
    const { Name, Id } = currentPanel;

    if (Name == "") {
      alert("Please select a valid name");
      return;
    }
    window.Spinner.show();
    window.DataGate.renameGeneralTaskPanel(Id, Name, (code, data) => {
      try {
        data = JSON.parse(data);
        window.DataStorage.setGeneralTaskPanels(data);
        const panelsVisibility =
          window.GlobalData.getGeneralTaskPanelsVisibility();

        setPanels(
          window.DataStorage.getGeneralTaskPanels().map((panel) => {
            return {
              ...panel,
              editable: panel.OwnerId === window.myid,
              isVisible: panelsVisibility.find((p) => p.Id === panel.Id)
                ? panelsVisibility.find((p) => p.Id === panel.Id).isVisible
                : true,
            };
          })
        );
      } catch (ex) {
        console.error("Cannot parse server response ", ex);
      } finally {
        window.Spinner.hide();
      }
    });
    setCurrentPanel(null);
  };

  const renderEditPanelModalBody = (ev_value, ev_dispatcher) => {
    return (
      <>
        <input
          type="text"
          value={ev_value.Name}
          onChange={(e) =>
            ev_dispatcher({ ...ev_value, Name: e.currentTarget.value })
          }
          placeholder={window.lang.name}
          className="field-manager--modal-text-input"
        />
      </>
    );
  };

  const toggleIsVisible = (panel) => {
    const newPanels = panels.map((p) => {
      if (p.Id === panel.Id) {
        return { ...p, isVisible: !p.isVisible };
      }
      return p;
    });
    setPanels(newPanels);

    window.GlobalData.setGeneralTaskPanelsVisibility(
      newPanels.map((panel) => {
        return {
          Id: panel.Id,
          isVisible: panel.isVisible,
        };
      })
    );
  };

  const renderIsVisibleIcon = (panel) => {
    return panel.isVisible ? (
      <svg
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
      </svg>
    ) : (
      <svg
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
        />
      </svg>
    );
  };

  return (
    <>
      <div className="field-manager--scroll-area">
        <div className="field-manager--holder">
          <table className="VaccinationTable" style={{ minWidth: 300 }}>
            <thead>
              <tr>
                <th>{window.lang.name}</th>
                <th>{window.lang.isVisible}</th>
                <th>{window.lang.edit}</th>
              </tr>
            </thead>
            <tbody>
              {panels.map((panel, index) => (
                <tr key={panel.Id}>
                  <td>{panel.Name}</td>
                  <td>
                    <div
                      className="actionIcon contentCentered"
                      onClick={() => toggleIsVisible(panel)}
                    >
                      {renderIsVisibleIcon(panel)}
                    </div>
                    {/* {panel.isVisible ? (
                      <img
                        className="actionIcon"
                        src="css/images/icons-png/eye-white.png"
                        onClick={() => toggleIsVisible(panel)}
                      />
                    ) : (
                      <img
                        className="actionIcon"
                        src="img/eye-black.png"
                        onClick={() => toggleIsVisible(panel)}
                      />
                    )} */}
                  </td>
                  <td>
                    {panel.editable && (
                      <img
                        className="actionIcon"
                        src="img/edit_icon.png"
                        onClick={() => setCurrentPanel(panel)}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {currentPanel && (
        <Modal
          title="Rename Panel"
          body={renderEditPanelModalBody(currentPanel, setCurrentPanel)}
          button1_text={window.lang.add}
          button2_text={window.lang.cancel2}
          button2_callback={() => setCurrentPanel(null)}
          button1_callback={renameCurrentPanel}
        />
      )}
    </>
  );
}

export default class GeneralTaskPanelsManagerHolder {
  createGeneralTaskPanelsManager() {
    ReactDOM.render(
      <GeneralTaskPanelsManager />,
      document.getElementById("generalTaskPanelsPageReact")
    );
  }
}
